import { useCopy } from "@/lib/contexts/appContext"

const useStrings = () => {
  const copy = useCopy()

  return copy?.general?.i18n ?? {}
}

export { useStrings as default }
